import React, { useEffect, useMemo, useRef, useReducer, useState, useContext } from 'react';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros'; 
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { Tooltip } from '../../components/utils/Tooltip';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { BotonExportarExcel } from '../../components/buttons/BotonExportarExcel';
import { BotonGeneral } from '../../components/buttons/BotonGeneral';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { SearchTable } from '../../components/utils/SearchTable';
import { DatePickerABX } from '../../components/pickers/DatePicker';
import { useOrdenTrabajo } from '../../../hooks/gestionMantenimientos/useOrdenTrabajo';
import { capitalLetter, dateTimeToString, enviarImagenMinio, formatDate, notify, stringToDateTime } from '../../../utils/utils';
import { useUnidades } from '../../../hooks/gestionMantenimientos/useUnidades';
import { useSettings } from '../../../hooks/gestionMantenimientos/useSettings';
import { useBIM } from '../../../hooks/gestionMantenimientos/useBIM';
import { SelectMultiple } from '../../components/forms/SelectMultiple';
import { useKilometraje } from '../../../hooks/registros/useKilometraje';
import { useBloqueoPantalla } from '../../../hooks/useBloqueoPantalla';
import { AutoCompleteV2 } from '../../components/forms/AutoCompleteV2';
import { useKardex } from '../../../hooks/reportes/useKardex';
import { Select2 } from '../../components/forms/Select2';
import { UserContext } from '../../../context/provider/UserProvider';
import ReactTooltip from 'react-tooltip';

import agregarImagen from '../../../assets/images/agregarImagen.jpg'
import { useMovimientos } from '../../../hooks/almacen/useMovimientos';
import { DateTimePicker } from '../../components/pickers/DateTimePicker';
import EnlazeDesenlazeNeumatico from '../../components/pages/Neumaticos/EnlazeDesenlazeNeumatico';
import { useMantenimientosDefinidos } from '../../../hooks/gestionMantenimientos/useMantenimientosDefinidos';
import ImpresionDiagnostico from '../../components/impresiones/ImpresionDiagnostico';

import ReactToPrint from 'react-to-print';
import { GuiaDeSalida } from '../../components/impresiones/GuiaDeSalida';
import { useProductos } from '../../../hooks/almacen/useProductos';

export const OrdenTrabajo = () => {
    const diagnosticoRef = useRef()
    
    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white"   
    const repuestoDiagnosticoDefault = {
        codArticulo: 0,
        cantidad: 0,
        precioCosto: 0,
    }
    const coloresEstados = {
        9:  'bg-[#f0ad4e]',      // PENDIENTE
        36: 'bg-[#5bc0de]',     // DIAGNOSTICADO
        18: 'bg-[#337ab7]',     // ATENDIDO
        39: 'bg-[#c0c0c0]',      // FINALIZADO
        37: 'bg-[#5cb85c]'      // AUTORIZADO
    }

    const { stateUser , signOut } = useContext(UserContext);
    const PERMISO_TALLER = stateUser.listPermisos.find(e => e.nomMenuAccion == 'Taller').codEstado == 1
    const PERMISO_PLANIFICADOR = stateUser.listPermisos.find(e => e.nomMenuAccion == 'Planificador').codEstado == 1

    const [isOpenRegistro, openModalRegistro, closeModalRegistro] = useModal()
    const [isOpenBims, openModalBims, closeModalBims] = useModal()
    const [isOpenModalEliminar,openModalEliminar,closeModalEliminar] = useModal()
    const [isOpenModalDiagnostico,openModalDiagnostico,closeModalDiagnostico] = useModal()
    const [isOpenModalTracking,openModalTracking,closeModalTrancking] = useModal()
    
    const [bloquearPantalla,desbloquearPantalla,ComponenteBloqueo] = useBloqueoPantalla()

    const [startDate, setStartDate] = useState(() => {
        const today = new Date(); // Obtener la fecha actual
        const sevenDaysAgo = new Date(today); // Crear una copia de la fecha actual
        sevenDaysAgo.setDate(today.getDate() - 15); // Restar 7 días a la copia
        return sevenDaysAgo; // Retornar la fecha como valor inicial del estado
    });
    const [ endDate, setEndDate ] = useState(new Date())
    const [estadoSeleccionado,setEstadoSeleccionado] = useState(0)
    const [ listaBimsSeleccionado, setListaBimsSeleccionados] = useState([])
    const [textoEliminacion,setTextoEliminacion] = useState('')
    const [elementosTablaDiagnostico,setElementosTablaDiagnostico] = useState([repuestoDiagnosticoDefault])
    const [txtDiagnosticoTaller,setTxtDiagnosticoTaller] = useState('')
    const [txtAprobacionTaller,setTxtAprobacionTaller] = useState('')

    const [menuActualTracking,setMenuActualTracking] = useState('')
    const [opcionesDesplegadas,setOpcionesDesplegadas] = useState(false)

    // VARIABLES ATENDER
    const [mecanicoAtencion,setMecanicoAtencion] = useState(0)
    const [comentarioAtencion,setComentarioAtencion] = useState('')
    const [fechaInicioAtencion,setFechaInicioAtencion] = useState(new Date())
    const [fechaFinAtencion,setFechaFinAtencion] = useState(new Date())
    const [imagenAtencion,setImagenAtencion] = useState('')
    const refImg = useRef()
    const refInputImg = useRef()

    // VARIABLES FINALIZACION
    const [conductorFinalizacion,setConductorFinalizacion] = useState(0)
    const [comentarioFinalizacion,setComentarioFinalizacion] = useState('')
    const [fechaFinalizacion,setFechaFinalizacion] = useState(new Date())

    const [mantenimientoPlantillaActual,setMantenimientoPlantillaActual] = useState(0)
    

    const {
        listarUltimasLecturas,
        ultimasLecturas
    } = useKilometraje()

    const {
        listarComboPersonasTaller,
        personasTaller
    } = useMovimientos()
    
    const {
        orden,
        setOrden,
        editarValorOrden,
        ordenDefault,
        listarOrdenes,
        ordenes,
        registrarEditarOrden,
        eliminarOrden,
        obtenerUltimoDocumentoOT,
        ultimoDocumentoOT,

        listarBimsPendientesPorUnidad,
        bimsPendientesPorUnidad,

        listarComboEstados,
        estados,

        registrarDiagnosticoTaller,

        listarDetalladoDiagnosticoTaller,
        detalladoDiagnosticoTaller,

        apruebaDiagnosticoTaller,
        finalizaDiagnosticoTaller,


        atenderOTNuevo,
        finalizarOTNuevo
    } = useOrdenTrabajo()

    const {
        unidadesSinOT,
        listaUnidadesSinOT
    } = useUnidades()

    const {
        listarConductores,
        conductores
    } = useSettings()

    const {
        autocompleteProductos,
        productos
    } = useKardex()

    const {
        listarMantenimientos,
        mantenimientos,
        listarDetalladoProductos
    } = useMantenimientosDefinidos()

    const {
        listarProductosYServicios,
        listaProductosYServicios,
    } = useProductos()


    useEffect(() => {
        const funcionReady = async () => {
            bloquearPantalla()
            await listarComboPersonasTaller()
            await listarProductosYServicios(0)
            await listarComboEstados()
            await listaUnidadesSinOT()
            await listarConductores()
            await funcionListarTabla()
            desbloquearPantalla()
        }

        funcionReady()
    }, [])

    useEffect(() => {
        editarValorOrden('ultimoKilometraje',ultimasLecturas)
    },[ultimasLecturas])

    useEffect(() => {
        if(Object.keys(detalladoDiagnosticoTaller).length != 0){
            const concatenadoProductos = detalladoDiagnosticoTaller.repuestoDetalle.split('~')
            setElementosTablaDiagnostico(concatenadoProductos.map(data => {
                // RespuestoDetalle = CodRepuesto*NombreRepuesto*Caracteristicas*Cantidad*RegistraSerie*CodRepuestoTipo~
                const datos = data.split('*')
                return {
                    codArticulo: datos[0],
                    cantidad: datos[4],
                    precioCosto: datos[5],
                }
            }))
            setMecanicoAtencion(detalladoDiagnosticoTaller.codPersonaMecanico)
            setComentarioAtencion(detalladoDiagnosticoTaller.comentario)
            setFechaInicioAtencion(detalladoDiagnosticoTaller.fechaHoraInicio ? new Date(stringToDateTime(detalladoDiagnosticoTaller.fechaHoraInicio)) : new Date())
            setFechaFinAtencion(detalladoDiagnosticoTaller.fechaHoraFin ? new Date(stringToDateTime(detalladoDiagnosticoTaller.fechaHoraFin)) : new Date())
            setConductorFinalizacion(detalladoDiagnosticoTaller.codPersonaConductorValidacion)
            setComentarioFinalizacion(detalladoDiagnosticoTaller.comentarioFinalizacion)
            setFechaFinalizacion(detalladoDiagnosticoTaller.fechaHoraFinalizacion ? new Date(stringToDateTime(detalladoDiagnosticoTaller.fechaHoraFinalizacion)) : new Date())

            setTxtDiagnosticoTaller(detalladoDiagnosticoTaller.comentarioDiagnosticoTaller)
            setTxtAprobacionTaller(detalladoDiagnosticoTaller.comentarioAprobacion)
        }else{
            setTxtDiagnosticoTaller('')
            setTxtAprobacionTaller('')
        }
    },[detalladoDiagnosticoTaller])

    useEffect(() => {
        if(Object.keys(bimsPendientesPorUnidad).length != 0){
            bimsPendientesPorUnidad.cantidadBimUnidad != 0 && openModalBims()
        }
    },[bimsPendientesPorUnidad])


    const funcionListarTabla = async () => {
        await listarOrdenes(formatDate(startDate),formatDate(endDate),estadoSeleccionado)
    }

    const funcionRegistrarEditar = async () => {
        const jsonData = await registrarEditarOrden()

        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')

        if(jsonData.CodResultado == 1){
            closeModalRegistro()
            await funcionListarTabla()
        }
    }

    const funcionEliminarOrdenTrabajo = async () => {
        const jsonData = await eliminarOrden(textoEliminacion)
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalEliminar()
            await funcionListarTabla()
        }
    }

    const funcionRegistroDiagnostico = async () => {
        if((JSON.stringify(elementosTablaDiagnostico) == JSON.stringify([repuestoDiagnosticoDefault])) || elementosTablaDiagnostico.some(e => [e.codArticulo,e.cantidad].includes(0))){
            notify('Elegir articulos y cantidades validas','info')
            return
        }
        
        const jsonData = await registrarDiagnosticoTaller({
            comentarioDiagnostico: txtDiagnosticoTaller,
            codigoOrdenTrabajo: orden.codOrdenTrabajo,
            listadoRepuestos: elementosTablaDiagnostico.map(data => {
                return {
                    codRepuesto: data.codArticulo,
                    cantidad: data.cantidad,
                    descripcionRepuesto: ''
                }
            })
        })
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalDiagnostico()
            closeModalTrancking()
            await funcionListarTabla()
        }
    }

    const funcionAprobacionDiagnostico = async (aprobar) => {
        const jsonData = await apruebaDiagnosticoTaller({
            codigoDiagnostico: orden.codDiagnosticoTaller,
            comentarioPlanificador: txtAprobacionTaller,
            aprobar: aprobar
        })
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalDiagnostico()
            closeModalTrancking()
            await funcionListarTabla()
        }
    }

    const funcionFinalizarDiagnostico = async () => {
        const jsonData = await finalizaDiagnosticoTaller(orden.codDiagnosticoTaller)
        notify(jsonData.DesResultado, jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalDiagnostico()
            closeModalTrancking()
            await funcionListarTabla()
        }
    }

    // NUEVAS FUNCIONES PARA EL MODAL TRACKING
    const funcionAtenderOTNuevo = async () => {
        // GUARDAR IMAGEN ANTES DE ATENDER LA OT
        const files = refInputImg.current.files

        if(mecanicoAtencion == 0){
            notify('Elegir el mecánico encargado','info')
            return
        }

        const urlImagenMinio =
            files.length > 0 ? 
                await enviarImagenMinio({
                    nombreCarpeta: "tgps",
                    nombreArchivo: `%2Ffotos-personas%2Forden-trabajo-${orden.codOrdenTrabajo}`,
                    file: files[0],
                })
            : "";

        const jsonData = await atenderOTNuevo({
            codigoOT: orden.codOrdenTrabajo,
            comentario: comentarioAtencion,
            fechaHoraInicio: dateTimeToString(fechaInicioAtencion),
            fechaHoraFin: dateTimeToString(fechaFinAtencion),
            urlImagen: urlImagenMinio || '',
            codPersonaMecanico: mecanicoAtencion
        })
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalDiagnostico()
            closeModalTrancking()
            await funcionListarTabla()
        }
    }
    const funcionFinalizarOTNuevo = async () => {
        const jsonData = await finalizarOTNuevo({
            codPersonaConductor: conductorFinalizacion,
            fecha: dateTimeToString(fechaFinalizacion),
            comentario: comentarioFinalizacion,
            codigoOT: orden.codOrdenTrabajo
        })
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalDiagnostico()
            closeModalTrancking()
            await funcionListarTabla()
        }
    }

    // PARA EL MODAL DEL TRACKING
    /*
        ESTADOS:    Pendiente(9), Diagnosticado(36), Autorizado(37), Atendido(18), FInalizado(39)
        ACCIONES:   Diagnosticar, Aprobar, Atender, Finalizar

        Diagnosticar -> cuando esta en PENDIENTE
        Aprobar -> cuando esta en DIAGNOSTICADO
        -- cuando pase a AUTORIZADO se mantiene en la accion APROBAR pero con el spinner indicando que el proceso esta a la espera de aprobacion del almacen
        Atender -> cuando esta en ATENDIDO      ????    -- aca podria pasar a estado APROBADO 
        Finalizar -> cuando esta en FINALIZAR ????  -- posiblemente se necesite un estado nuevo al que pase luego de FINALIZAR
*/
    const ESTADOS_TRACKING = 
    [
        {
            estados: [9],
            accion: 'DIAGNOSTICAR'
        },
        {
            estados: [36],
            accion: 'APROBAR'
        },
        {
            estados: [37],
            accion: 'ATENDER'
        },
        {
            estados: [18,39],
            accion: 'FINALIZAR'
        }
    ]

    const VistaBotonesModal = () => {
        const indiceEstadoActual = orden.pendienteDespachoAlmacen ? 1 : ESTADOS_TRACKING.findIndex(e => e.estados.includes(orden.codEstado))
        
        return (
            <div className='flex flex-col lg:flex-row gap-1 p-2 bg-[#252323]'>
                {
                    ESTADOS_TRACKING.map((data,i) => {
                        return(
                            <div 
                                key={i+1} 
                                onClick={() => {
                                    if(i <= indiceEstadoActual){
                                        setMenuActualTracking(data.estados[0])
                                    }
                                }}      // CORREGIR CUANDO EL NUMERO DE ESTADOS PARA UNA ACCION SEA MAS DE UNO
                                className={`
                                    ${data.estados.includes(menuActualTracking) ? '!bg-[#1d4ed8] border-[#9ba9aa] !text-white font-bold' : ''} 
                                    ${i <= indiceEstadoActual ? 'bg-[#3b82f6] hover:shadow-[inset_0_-2px_6px_rgba(0,0,0,0.6)] hover:bg-[#2563eb]' : ' border' } 
                                    ${i > indiceEstadoActual ? 'cursor-not-allowed' : ''}
                                    w-[200px] h-[80px] lg:h-[40px] text-xs flex items-center justify-center border rounded cursor-pointer
                                `}
                            >
                                <span className={`${i == indiceEstadoActual ? 'animate-bounce' : ''}`}>{data.accion}</span>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    const VistaMenuModal = () => {
        const ComponenteCabecera = () => {
            return(
                <div className='flex flex-col gap-2'>
                    <div className='grid grid-cols-2'>
                        <div className="grid grid-cols-3 lg:grid-cols-1 gap-4 lg:gap-2">
                            <div className='flex gap-2 items-center'>
                                <i className="fa fa-file-text text-right" aria-hidden="true"></i>
                                <span>O.T:</span>
                            </div>
                            <span className='text-sm col-span-2'>{orden.numDocumentoOT}</span>
                            <div className='flex gap-2 items-center'>
                                <i className="fa fa-bus" aria-hidden="true"></i>
                                <span>Unidad:</span>
                            </div>
                            <span className='text-sm col-span-2'>{orden.unidad}</span>
                            <div className='flex gap-2 items-center'>
                                <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                <span>Comentario:</span>
                            </div>
                            <span className='text-sm col-span-2'>{orden.comentarioOrdenTrabajo}</span>
                        </div>
                        <div className="grid grid-cols-3 lg:grid-cols-1 gap-4 lg:gap-2 items-start h-fit">
                            <div className='flex gap-2 items-center'>
                                <i className="fa fa-calendar text-right" aria-hidden="true"></i>
                                <span>Fecha:</span>
                            </div>
                            <span className='text-sm col-span-2'>{orden.fechaHoraInicio}</span>
                            <div className='flex gap-2 items-center'>
                                <i className="fa fa-user" aria-hidden="true"></i>
                                <span>Conductor:</span>
                            </div>
                            <span className='text-sm col-span-2'>{orden.nomPersonaConductor}</span>
                        </div>
                    </div>
                </div>
            )
        }
        const ComponenteTabla = () => (
            <div className={`flex border-collapse flex-col gap-2 ${orden.codEstado == 9 ? '' : 'pointer-events-none'}`}>
                <table className='table border-collapse lg:w-full containerScroll max-h-[200px] overflow-y-auto overflow-x-hidden'>
                    <thead>
                        <tr>
                            <th>Nº</th>
                            <th>ARTÍCULO</th>
                            <th>CANTIDAD</th>
                            <th>PRECIO UNITARIO</th>
                            <th>IMPORTE</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            elementosTablaDiagnostico.map((data,i) => 
                                <tr key={i+1}>
                                    <td className='text-center'>{i+1}</td>
                                    <td className='text-center w-[200px]'>
                                        <div className=''>
                                            <Select2
                                                disabled={orden.codDiagnosticoTaller != 0 ? true : false}
                                                opciones={ [ {text: '-- Seleccione --',value: 0} , ...listaProductosYServicios.map((data,i) => ({text: data.nombreRepuesto,value:data.codRepuesto})) ] }
                                                value={data.codArticulo}
                                                functionChangeValue={(valor) => {
                                                        if(elementosTablaDiagnostico.some(e => e.codArticulo == Number(valor))){
                                                            notify('El articulo ya ha sido elegido','info')
                                                        }else{
                                                            setElementosTablaDiagnostico(elementosAnteriores => {
                                                                const copiaElementos = [...elementosAnteriores]
                                                                copiaElementos[i].codArticulo = Number(valor)
                                                                copiaElementos[i].cantidad = 1
                                                                copiaElementos[i].precioCosto = listaProductosYServicios.find(elem => elem.codRepuesto == valor)?.precioCosto || 0
                                                                return copiaElementos
                                                            })
                                                        }
                                                    
                                                }}
                                            ></Select2>
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <input type='number' min={0} disabled={orden.codDiagnosticoTaller != 0 ? true : false} onKeyUp={(e) => {
                                            if(e.keyCode == 13){
                                                if(elementosTablaDiagnostico.some(e => [e.codArticulo,e.cantidad].includes(0))){
                                                    notify('Seleccionar un artículo y cantidad valida','info')
                                                }else{
                                                    setElementosTablaDiagnostico(elementosAnteriores => {
                                                        return [...elementosAnteriores,repuestoDiagnosticoDefault]
                                                    })
                                                }
                                            }
                                        }} value={data.cantidad} onChange={(e) => {
                                            setElementosTablaDiagnostico(elementosAnteriores => {
                                                const copiaElementos = [...elementosAnteriores]
                                                copiaElementos[i].cantidad = Number(e.target.value)
                                                return copiaElementos
                                            })
                                        }}  className={`${classNameInput} w-[80px]`} />
                                    </td>
                                    <td className='text-center whitespace-nowrap'>s/. {(data.precioCosto)}</td>
                                    <td className='text-center whitespace-nowrap'>s/. {(data.cantidad * data.precioCosto)}</td>
                                    <td className='text-center'><i onClick={() => {
                                        if(elementosTablaDiagnostico.length == 1){
                                            setElementosTablaDiagnostico([repuestoDiagnosticoDefault])
                                        }else{
                                            setElementosTablaDiagnostico(arrAnterior => {
                                                const copiaElementos = [...arrAnterior]
                                                copiaElementos.splice(i,1)
                                                return copiaElementos
                                            })
                                        }
                                    }} className="fa fa-trash text-red-600" aria-hidden="true"></i></td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        )
        const ComponenteComentarioDiagnostico = () => (
            <div className='flex flex-col gap-2'>
                <span>Comentario:</span>
                <textarea disabled={orden.codEstado != 9} value={txtDiagnosticoTaller} onChange={e => setTxtDiagnosticoTaller(e.target.value)} className={`${classNameInput} h-[80px] p-2`}></textarea>
            </div>
        )
        const ComponenteComentarioPlanificador = () => (
            <div className='flex flex-col gap-2'>
                <span>Comentario:</span>
                <textarea disabled={orden.codEstado != 36} value={txtAprobacionTaller} onChange={e => setTxtAprobacionTaller(e.target.value)} className={`${classNameInput} h-[80px] p-2`}></textarea>
            </div>
        )



        const MenuDiagnosticar = () => {
            return(
                <div className='flex flex-col gap-4 w-full h-full items-center justify-start'>
                    <div className='w-3/4 lg:w-full flex flex-col gap-4'>
                        <fieldset className='border border-gray-600 rounded-md p-4'>
                            <div className={`flex items-center gap-2 ${orden.codEstado == 9 ? '' : 'hidden'}`}>
                                <select value={mantenimientoPlantillaActual} onChange={e => setMantenimientoPlantillaActual(e.target.value)} className={`${classNameInput}`}>
                                    <option value="0">-- Seleccione --</option>
                                    {
                                        mantenimientos.map((data,i) => (
                                            <option key={i+1} value={data.codMantenimientoPlantilla}>{data.nomMantenimientoPlantilla}</option>
                                        ))
                                    }
                                </select>
                                <button onClick={async () => {
                                    const response = await listarDetalladoProductos(mantenimientoPlantillaActual)
                                    setElementosTablaDiagnostico((arrAnterior) => {
                                        const nuevosElementos = response.map(data => ({
                                            codArticulo:    data.codRepuesto || 0,
                                            cantidad:       data.cantidad || 0,
                                            precioCosto:    data.precioCosto || 0
                                        }))
                                        return [...nuevosElementos,...arrAnterior]
                                    })
                                    setMantenimientoPlantillaActual(0)
                                }} className='rounded bg-green-600 py-2 px-2 text-xs whitespace-nowrap'><i className="fa fa-plus" aria-hidden="true"></i> Agregar grupo</button>
                            </div>
                        </fieldset>
                        
                        <fieldset className='border border-gray-600 rounded-md p-4 flex flex-col border-collapse'>
                            <span className=''>Repuestos:</span>
                            {ComponenteTabla()}
                        </fieldset>
                        
                        <fieldset className='border border-gray-600 rounded-md p-4'>
                            {ComponenteComentarioDiagnostico()}
                        </fieldset>
                        
                        <div className={`${orden.codEstado == 9 && PERMISO_TALLER ? 'flex' : 'hidden'} justify-end w-full gap-4`}>
                            <button onClick={funcionRegistroDiagnostico} className='hover:scale-105 px-6 py-2 bg-blue-600 rounded w-fit text-sm'>Guardar</button>
                        </div>
                    </div>
                </div>
            )
        }
        const MenuAprobar = () => {
            return(
                <div className='flex flex-col gap-4 w-full h-full items-center justify-center'>
                    <div className='w-3/4 lg:w-full flex flex-col gap-4'>
                        {ComponenteComentarioPlanificador()}
                        {
                            orden.pendienteDespachoAlmacen ?
                            ''
                            :
                                orden.codEstado == 36 && PERMISO_PLANIFICADOR ? 
                                <div className={`flex justify-end w-full gap-4`}>
                                    <button onClick={() => funcionAprobacionDiagnostico(true)} className='hover:scale-105 px-6 py-2 bg-green-600 rounded w-fit text-sm'>Aprobar</button>
                                    <button onClick={() => funcionAprobacionDiagnostico(false)} className='hover:scale-105 px-6 py-2 bg-red-600 rounded w-fit text-sm'>Rechazar</button>
                                </div>
                                : ''
                        }
                    </div>
                </div>
            )
        }
        const MenuAtender = () => {
            return(
                <div className='flex flex-col gap-4 w-full h-full items-center justify-center'>
                    <div className='w-4/5 lg:w-full flex flex-col gap-8'>
                        <div className='flex lg:flex-col gap-8'>
                            <div className="flex flex-col gap-2 w-2/3 lg:w-full">
                                <div className='flex flex-col gap-2'>
                                    <span>Mecánico:</span>
                                    <div>
                                        <Select2
                                            value={mecanicoAtencion}
                                            opciones={[
                                                {
                                                    text: '--Seleccione--',
                                                    value: 0
                                                },
                                                ...personasTaller.map((data,i) => {
                                                    return({
                                                        text: data.nomPersona,
                                                        value: data.codPersona
                                                    })
                                                })
                                            ]}
                                            functionChangeValue={(value) => setMecanicoAtencion(value)}
                                            disabled={orden.codEstado == 37 ? false : true}
                                        ></Select2>
                                    </div>
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <span>Comentario:</span>
                                    <textarea disabled={orden.codEstado == 37 ? false : true} value={comentarioAtencion} onChange={(e) => setComentarioAtencion(e.target.value)} placeholder='(Comentario)' className={`${classNameInput} w-full p-2 h-[60px]`}></textarea>
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <span className='whitespace-nowrap'>Inicio atención:</span>
                                    {/* <DatePickerABX
                                        date={fechaInicioAtencion}
                                        setDate={setFechaInicioAtencion}
                                        styles={{width:'100%'}}
                                    ></DatePickerABX> */}
                                    <DateTimePicker
                                        date={fechaInicioAtencion}
                                        setDate={setFechaInicioAtencion}
                                        styles={{width:'100%'}}
                                        disabled={orden.codEstado == 37 ? false : true}
                                    ></DateTimePicker>
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <span className='whitespace-nowrap'>Fin atención:</span>
                                    {/* <DatePickerABX
                                        date={fechaFinAtencion}
                                        setDate={setFechaFinAtencion}
                                        styles={{width:'100%'}}
                                    ></DatePickerABX> */}
                                    <DateTimePicker
                                        date={fechaFinAtencion}
                                        setDate={setFechaFinAtencion}
                                        styles={{width:'100%'}}
                                        disabled={orden.codEstado == 37 ? false : true}
                                    ></DateTimePicker>
                                </div>
                            </div>

                            <div className="flex flex-col flex-1 justify-center items-center">
                                <div className='hover:scale-105 h-[150px] w-full rounded-sm shadow shadow-black overflow-hidden cursor-pointer'>
                                    <img ref={refImg} src={detalladoDiagnosticoTaller.urlImagen || agregarImagen} onClick={e => orden.codEstado == 37 && refInputImg.current.click()} className='w-full h-full' />
                                </div>
                                <input ref={refInputImg} onChange={e => {
                                    refImg.current.src = URL.createObjectURL(e.target.files[0])
                                }} type="file" className='hidden' accept='.png,.jpg,.jpeg' />
                            </div>
                        </div>

                        {
                            detalladoDiagnosticoTaller.afectaNeumatico && orden.codEstado == 37 ?   // UNO DE SUS REPUESTOS TIENE AFECTANEUMATICO Y LA OT ESTA EN ESTADO AUTORIZADO
                            <EnlazeDesenlazeNeumatico
                                ocultarParaEdicion={true}
                                codigoOrdenTrabajoProp={orden.codOrdenTrabajo}
                            />
                            : ''
                        }
                        
                        <div className={`${orden.codEstado == 37 && PERMISO_TALLER ? 'flex' : 'hidden'} w-full text-center flex justify-start`}>
                            <button onClick={funcionAtenderOTNuevo} className='hover:scale-105 px-6 py-2 bg-blue-600 rounded w-fit text-sm'>Confirmar atención</button>
                        </div>
                    </div>
                </div>
            )
        }
        const MenuFinalizar = () => {
            return(
                <div className='flex flex-col gap-4 w-full h-full items-center justify-center'>
                    <div className='w-3/4 lg:w-full flex flex-col gap-8'>
                        <div className='flex flex-col gap-2'>
                            <span>Conductor:</span>
                            <div>
                                <Select2
                                    value={conductorFinalizacion}
                                    opciones={[
                                        {
                                            text: '--Seleccione--',
                                            value: 0
                                        },
                                        ...conductores.map((data,i) => {
                                            return({
                                                text: data.nomPersona,
                                                value: data.codPersona
                                            })
                                        })
                                    ]}
                                    functionChangeValue={(value) => setConductorFinalizacion(value)}
                                    disabled={orden.codEstado == 18 ? false : true}
                                ></Select2>
                            </div>
                        </div>
                        <div className='flex flex-col gap-2'>
                            <span className='whitespace-nowrap'>Fecha validación:</span>
                            {/* <input className={classNameInput} defaultValue={'18/05/24'} /> */}
                            {/* <DatePickerABX
                                date={fechaFinalizacion}
                                setDate={setFechaFinalizacion}
                                styles={{width:'100%'}}
                            ></DatePickerABX> */}
                            <DateTimePicker
                                date={fechaFinalizacion}
                                setDate={setFechaFinalizacion}
                                styles={{width:'100%'}}
                                disabled={orden.codEstado == 18 ? false : true}
                            ></DateTimePicker>
                        </div>
                        <div className='flex flex-col gap-2'>
                            <span>Comentario:</span>
                            <textarea disabled={orden.codEstado == 18 ? false : true} value={comentarioFinalizacion} onChange={e => setComentarioFinalizacion(e.target.value)} placeholder='(Comentario)' className={`${classNameInput} p-2 h-[60px]`}></textarea>
                        </div>
                        <div className={`${orden.codEstado == 18 && PERMISO_PLANIFICADOR ? 'flex' : 'hidden'} w-full justify-end gap-2`}>
                            {/* <button onClick={funcionFinalizarDiagnostico} className={`${orden.codEstado == 18 ? '' : 'hidden'} hover:scale-105 px-6 py-2 bg-blue-600 rounded w-fit text-sm`}>Finalizar</button> */}
                            <button onClick={funcionFinalizarOTNuevo} className={`hover:scale-105 px-6 py-2 bg-blue-600 rounded w-fit text-sm`}>Guardar</button>
                        </div>
                    </div>
                </div>
            )
        }
        

        const menus = [
            {estados: [9],          contenido: MenuDiagnosticar()},
            {estados: [36],         contenido: MenuAprobar()},
            {estados: [37],         contenido: MenuAtender()},
            {estados: [18,39],      contenido: MenuFinalizar()}  // Cuando esta en 39 ya se cerro esa OT (disabled)
        ]

        const Menu = (contenido) => {
            return (
            <div className='w-[800px] lg:w-full border-gray-400 overflow-auto containerScroll flex flex-col gap-2'>
                <div className='w-full flex justify-end relative p-2 bg-[#232323]'>
                    <button onClick={() => setOpcionesDesplegadas(!opcionesDesplegadas)} className='rounded py-2 px-4 bg-[#141414] text-xs flex gap-2 items-center justify-center'>Detalles <i className={`fa ${opcionesDesplegadas ? 'fa-caret-up' : 'fa-caret-down'}`} aria-hidden="true"></i></button>
                    <div className={`${opcionesDesplegadas ? 'max-h-[300px] opacity-100 visble' : 'max-h-0 opacity-0 invisible'} overflow-hidden transition-all duration-500 ease-out absolute w-full top-full left-0 p-4 rounded-b-md bg-[#747980] z-20`}>
                        <ComponenteCabecera/>
                    </div>
                </div>
                <div className='p-2 flex-1'>
                    {contenido}
                </div>
            </div>)
        }

        return Menu(menus.find(e => e.estados.includes(menuActualTracking))?.contenido)
    }




    // MODALES
    const ModalTracking = () => {
        return(
            <Modal
                isOpen={isOpenModalTracking}
                closeModal={closeModalTrancking}
                title={`${orden.numDocumentoOT} - Unidad: [${orden.unidad}]`}
                validButton={{}}
                paddingModal={false}
            >
                <div className='flex lg:flex-col h-[550px] lg:h-full lg:min-h-[50vh] lg:text-xs'>
                    {VistaBotonesModal()}
                    {VistaMenuModal()}
                </div>
            </Modal>
        )
    }

    const ModalEditarRegistrarOT = () => {
        return(
            <Modal 
                isOpen={isOpenRegistro} 
                closeModal={closeModalRegistro} 
                action={funcionRegistrarEditar}
                title={orden.numDocumentoOT ? `Editar orden de trabajo [${orden.numDocumentoOT}]` : 'Nueva orden de trabajo'}
            >
                <div className="lg:w-full flex items-center flex-wrap justify-center">
                    <div className='lg:w-full flex flex-col gap-4 p-4'>
                        <div className='flex gap-6 items-start w-full pb-4'>
                            <div className='flex gap-4 items-center'>
                                <i className="fa fa-note-sticky" aria-hidden="true"></i>
                                {/* <input defaultValue={orden.numDocumentoOT || ultimoDocumentoOT} className={`${classNameInput} w-[150px]`} disabled/> */}
                                <span className='text-sm'>{orden.numDocumentoOT || ultimoDocumentoOT}</span>
                            </div>
                            <div className='flex gap-4 items-center'>
                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                {/* <input defaultValue={orden.fechaOrdenTrabajo || formatDate(new Date())} className={`${classNameInput} w-[150px]`} disabled/> */}
                                <span className='text-sm'>{orden.fechaOrdenTrabajo || formatDate(new Date())}</span>
                            </div>
                        </div>
                        <div className='lg:w-full flex lg:flex-col gap-4'>
                            <div className='flex gap-2 items-center'>
                                <i className="fa fa-bus" aria-hidden="true"></i>
                                <div className='w-[200px] lg:flex-grow'>
                                    {
                                        orden.numDocumentoOT ?
                                            <input className={classNameInput} value={orden.unidad} disabled></input>
                                        :
                                            <Select2
                                                tabIndexInput={1}
                                                opciones={[
                                                    {
                                                        text: '--Seleccione--',
                                                        value: 0
                                                    },
                                                    ...unidadesSinOT.map((data,i) => {
                                                        return{
                                                            text: data.nomUnidad,
                                                            value: data.codUnidad
                                                        }
                                                    })
                                                ]}
                                                value={orden.codUnidad}
                                                functionChangeValue={(codigoUnidad) => {
                                                    editarValorOrden('codUnidad',codigoUnidad)
                                                    listarUltimasLecturas(codigoUnidad)   //PARA OBTENER LA ULTIMA LECTURA DEL BUS
        
                                                    listarBimsPendientesPorUnidad(codigoUnidad)   // VER LOS BIMS QUE TIENE REGISTRADA ESTA UNIDAD
                                                    setListaBimsSeleccionados(() => {
                                                        return orden.codBitacoraIncidenciaMantenimiento?.split(',').map((data) => {
                                                            return {codBim: data}
                                                        }) || []
                                                    })
                                                    // openModalBims()
                                                }}
                                                disabled={orden.codOrdenTrabajo != 0 ? true : false}
                                            ></Select2>
                                    }
                                </div>
                                <button onClick={openModalBims} className='hover:scale-105 bg-blue-600 rounded py-1 px-2 text-sm'>BIM´S</button>
                            </div>
                            <div className='flex gap-2 items-center'>
                                <i className="fa fa-user" aria-hidden="true"></i>
                                <div className='w-[200px] lg:flex-grow'>
                                    <Select2
                                        tabIndexInput={2}
                                        value={orden.codPersonaConductor}
                                        opciones={[
                                            {
                                                text: '--Seleccione--',
                                                value: 0
                                            },
                                            ...conductores.map((data,i) => {
                                                return({
                                                    text: data.nomPersona,
                                                    value: data.codPersona
                                                })
                                            })
                                        ]}
                                        functionChangeValue={(valor) => editarValorOrden('codPersonaConductor',valor)}
                                    ></Select2>
                                </div>
                            </div>
                            <div className='flex gap-2 items-center'>
                                <i className="fa fa-tachometer" aria-hidden="true"></i>
                                <input value={`${orden.ultimoKilometraje} km`} className={`${classNameInput} w-[200px] lg:flex-grow`} disabled/>
                            </div>
                        </div>
                        <div className='flex items-center gap-2'>
                            <i className="fa fa-sticky-note-o" aria-hidden="true"></i>
                            <textarea tabIndex={3} value={orden.comentarioOrdenTrabajo} onChange={e => editarValorOrden('comentarioOrdenTrabajo',e.target.value)} placeholder='Ingrese la observacion de la OT' className={`${classNameInput} h-[60px] p-2 caret-white`}></textarea>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }

    // const ModalBIMsPendientes = () => {
    //     return(
            
    //     )
    // }

    const ModalEliminarOT = () => {
        return(
            <Modal 
                title={'Eliminar orden de trabajo'}
                isOpen={isOpenModalEliminar}
                action={funcionEliminarOrdenTrabajo}
                closeModal={closeModalEliminar}
                textButtons={{confirm:'Si',denied: 'No'}}
            >
                <div className='w-[400px] lg:w-full flex flex-col gap-4 p-4 text-center'>
                    <div>¿Está seguro de eliminar el registro?</div>
                    <textarea value={textoEliminacion} onChange={(e) => setTextoEliminacion(e.target.value)} placeholder='(Motivo)' className={`${classNameInput} h-[80px] p-2`}></textarea>
                </div>
            </Modal>
        )
    }


    return (
        <>
            <ComponenteBloqueo></ComponenteBloqueo>

            <div className='w-full h-full flex flex-col'>
                <ContenedorParametros
                    titulo='Orden de Trabajo' tablaId="tablaId"
                >   
                    <div className="flex items-center">
                        <i data-for='fechaInicio' className="mr-[10px] far fa-calendar-alt"></i>
                        <DatePickerABX className="" date={startDate} setDate={setStartDate}/>
                    </div>

                    <div className="flex items-center">
                        <i data-for='fechaFin' className="mr-[10px] far fa-calendar-alt"></i>
                        <DatePickerABX className="" date={endDate} setDate={setEndDate}/>
                    </div>

                    <label className='lg:hidden'>Estado:</label>
                    <div>
                        <select value={estadoSeleccionado} onChange={(e) => setEstadoSeleccionado(e.target.value)} className={`${classNameInput} `}>
                            <option value="0">Todos</option>
                            {
                                estados.map((data,i) => <option key={i+1} value={data.codEstado}>{data.nomEstado}</option>)
                            }
                        </select>
                    </div>

                    <BotonProcesar onClick={funcionListarTabla}></BotonProcesar>       
                    {
                        PERMISO_PLANIFICADOR ?
                        <BotonNuevo 
                            onClick={() => {
                                setOrden(ordenDefault)
                                obtenerUltimoDocumentoOT()
                                listaUnidadesSinOT()
                                openModalRegistro()
                            }}
                        ></BotonNuevo>
                        : ''
                    }
                </ContenedorParametros>
                
                <Tooltip id={'fechaInicio'}>Fecha Inicio</Tooltip>
                <Tooltip id={'fechaFin'}>Provincia</Tooltip>

                <div className="containerScroll mt-7 relative flex-1 overflow-auto">
                    <table id="tablaId" className="tableResponsive">
                        <thead>
                            <tr>
                                <th className="w-[20px]">N°</th>
                                <th className="w-[120px]">OT</th>
                                <th className="w-[200px]">UNIDAD</th>
                                <th className="w-[150px]">KM</th>
                                <th className="w-[150px]">CONDUCTOR</th>
                                <th className="w-[150px] whitespace-nowrap">FECHA INICIO</th>
                                {/* <th className="w-[150px] whitespace-nowrap">FECHA FINAL</th> */}
                                <th className="w-[35%]">MOTIVO</th>
                                <th className="">FLUJO</th>
                                <th className="">ESTADO</th>
                                <th className="w-[150px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {   
                            ordenes.length > 0 
                            ? ordenes.map((data, i) => {
                                const estadosAgrupados = [
                                    {
                                        nombre: 'NUEVO',
                                        valores: [9],
                                        color: 'bg-orange-600'
                                    },
                                    {
                                        nombre: 'EN PROCESO',
                                        valores: [36,37,18],
                                        color: 'bg-green-600'
                                    },
                                    {
                                        nombre: 'FINALIZADO',
                                        valores: [39],
                                        color: 'bg-gray-600'
                                    }
                                ]
                                const valorActual = estadosAgrupados.find(e => e.valores.includes(data.codEstado))
                                return (
                                    <tr key={i+1} className=''>
                                        <td data-label="" className='text-center w-[20px]'> {++i}</td>
                                        <td data-label="OT" className="text-center whitespace-nowrap">{data.numDocumentoOT}</td>
                                        <td data-label="Unidad" className="text-center w-[120px] whitespace-nowrap">{data.unidad}</td>
                                        <td data-label="Km" className="text-center w-[200px]">{data.ultimoKilometraje}</td>
                                        <td data-label="Conductor" className="text-center whitespace-nowrap">{data.nomPersonaConductor}</td>
                                        <td data-label="Fecha Inicio" className="text-center whitespace-nowrap">{data.fechaHoraInicio || '-'}</td>
                                        {/* <td data-label="Fecha Fin" className="text-center whitespace-nowrap">{data.fechaHoraFin || '-'}</td> */}
                                        <td data-label="Motivo" className="text-center w-[35%]">{data.comentarioOrdenTrabajo}</td>

                                        {/* PARA LA VISTA DEL TRACKING */}
                                        {/* <td data-label="Estado" className="text-center"><label className={`${coloresEstados[data.codEstado]} text-xs rounded px-2 py-1`}>{data.nomEstado}</label></td> */}
                                        <td data-label="Flujo" className='!flex justify-between'>
                                            <div 
                                                className='flex gap-1 hover:scale-105'
                                                onClick={() => {
                                                    setMenuActualTracking(data.pendienteDespachoAlmacen ? 36 : data.codEstado)                                                   // PARA QUE LA PESTAÑA DEL MENU ACTUAL APAREZCA SELECCIONADA    
                                                    data.codEstado != 9 ? listarDetalladoDiagnosticoTaller(data.codDiagnosticoTaller) : setTxtAprobacionTaller('');setTxtDiagnosticoTaller('')      // CUANDO ES CUALQUIER ESTADO MENOS PENDIENTE PARA LISTAR EL DETALLADO DEL D.T
                                                    setElementosTablaDiagnostico([repuestoDiagnosticoDefault])                              // PARA LIMPIAR LA TABLA DE REPUESTOS
                                                    setOrden(Object.assign({},ordenDefault,data))                                           // PARA LA INFORMACION DE LA TABLA DE REPUESTOS
                                                    openModalTracking()
                                                    listarMantenimientos()      // LISTA EL PLANTILLA MANTENIMIENTOS
                                                    setOpcionesDesplegadas(false)
                                                }} 
                                            >
                                                {
                                                    ESTADOS_TRACKING.map((data2,j) => {
                                                        const estadoActual = ESTADOS_TRACKING.find(e => e.estados.includes(data.codEstado))
                                                        const estaEnEspera = data.pendienteDespachoAlmacen
                                                        const estaFinalizado = estadoActual.estados.findIndex(e => e == data.codEstado) > 0
                                                        const indiceTracking = ESTADOS_TRACKING.findIndex(e => JSON.stringify(e) == JSON.stringify(estadoActual))

                                                        return (
                                                            // <React.Fragment key={j+1}>
                                                                <div 
                                                                    key={j+1}
                                                                    data-for={`accion-${j}-fila-${i}`}
                                                                    data-tip={data2.accion}
                                                                    className={`${(j < indiceTracking) || estaFinalizado ? 'bg-blue-600' : 'bg-gray-600'} flex items-center justify-center text-xs h-[30px] w-[30px] rounded relative`}
                                                                >
                                                                    {j+1}
                                                                    {
                                                                        estaEnEspera && j == (indiceTracking-1)?
                                                                        <i className="fa fa-spinner animate-spin absolute top-0 right-0 font-bold" aria-hidden="true"></i>
                                                                        : ''
                                                                    }
                                                                </div>
                                                            // </React.Fragment>
                                                        )
                                                    })
                                                }
                                                <ReactTooltip id={`accion-0-fila-${i}`} place='top' effect='solid' globalEventOff="scroll" />
                                                <ReactTooltip id={`accion-1-fila-${i}`} place='top' effect='solid' globalEventOff="scroll" />
                                                <ReactTooltip id={`accion-2-fila-${i}`} place='top' effect='solid' globalEventOff="scroll" />
                                                <ReactTooltip id={`accion-3-fila-${i}`} place='top' effect='solid' globalEventOff="scroll" />
                                            </div>
                                        </td>
                                        <td data-label="Estado" className='lg:!flex text-center justify-between'><div className={` rounded !text-xs !w-[90px] px-2 py-1 whitespace-nowrap text-center ${valorActual.color}`}>{capitalLetter(valorActual.nombre)}</div></td>
                                        
                                        <td data-label="Opciones" className="!flex w-full items-center justify-between whitespace-nowrap gap-3">
                                            {/* BOTON PARA EL DIAGNOSTICO DE TALLER */}
                                            {/* {
                                                data.codEstado == 9 && PERMISO_TALLER ?     // SOLO EL TALLER TIENE LA OPCION DE GENERAR EL D.T
                                                    <button
                                                        onClick={() => {
                                                            setElementosTablaDiagnostico([repuestoDiagnosticoDefault])
                                                            setTxtDiagnosticoTaller('')
                                                            openModalDiagnostico()
                                                            setOrden(Object.assign({},ordenDefault,data))
                                                        }}
                                                        title='Nuevo diagnostio de taller'
                                                        className="bg-[#5bc0de] hover:bg-blue-600 px-[5px] text-xs rounded h-[27px] flex items-center justify-center font-bold"
                                                    >D.T</button>
                                                : data.codEstado == 36 && PERMISO_PLANIFICADOR ?    // SOLO EL PLANIFICADOR TIENE LA OPCION DE APROBAR LA O.T
                                                    <button
                                                        title='Aprobar O.T'
                                                        onClick={() => {
                                                            setElementosTablaDiagnostico([repuestoDiagnosticoDefault])
                                                            listarDetalladoDiagnosticoTaller(data.codDiagnosticoTaller)
                                                            openModalDiagnostico()
                                                            setOrden(Object.assign({},ordenDefault,data))
                                                        }}
                                                        className="bg-[#5bc0de] hover:bg-blue-600 px-[5px] text-xs rounded h-[27px] flex items-center justify-center"
                                                    >
                                                        <i className="fa fa-check"></i>
                                                    </button>
                                                : data.codEstado == 18 && PERMISO_TALLER ?      // SOLO EL TALLER TIENE LA OPCION DE FINALIZAR LA O.T
                                                    <button
                                                        title='Finalizar O.T'
                                                        className="bg-[#5bc0de] relative hover:bg-blue-600 px-[5px] text-xs rounded h-[27px] flex items-center justify-center"
                                                        onClick={() => {
                                                            setElementosTablaDiagnostico([repuestoDiagnosticoDefault])
                                                            listarDetalladoDiagnosticoTaller(data.codDiagnosticoTaller)
                                                            openModalDiagnostico()
                                                            setOrden(Object.assign({},ordenDefault,data))
                                                        }}
                                                    >
                                                        <i className="fa fa-check"></i>
                                                        <i className="fa fa-check absolute translate-x-1"></i>
                                                    </button>
                                                : ''
                                            } */}
                                            <div className='flex gap-2 items-center justify-center'>
                                                {/* BOTON PARA EDITAR LA ORDEN DE TRABAJO */}
                                                {
                                                    data.codEstado == 9 && PERMISO_PLANIFICADOR ?      // SOLO EL PLANIFICADOR TIENE PERMISO DE REGISTRAR Y EDITAR LA O.T
                                                    <button
                                                        onClick={() => {
                                                            openModalRegistro()
                                                            setOrden(Object.assign({},ordenDefault,data))
                                                        }}
                                                        title='Editar O.T'
                                                        className="bg-blue-500 hover:bg-blue-600 px-[5px] text-xs rounded h-[27px] flex items-center justify-center"
                                                    >
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                    : ''
                                                }
                                                {/* BOTON PARA ELIMINAR LA ORDEN DE TRABAJO */}
                                                {
                                                    data.codEstado == 9 && PERMISO_PLANIFICADOR ?   // SOLO EL PLANIFICADOR TIENE EL PERMISO DE ELIMINAR LA O.T
                                                    <button 
                                                        onClick={() => {
                                                            openModalEliminar()
                                                            setTextoEliminacion('')
                                                            setOrden(Object.assign({},ordenDefault,data))
                                                        }} 
                                                        title='Eliminar'
                                                        className="bg-red-500 hover:bg-red-800 px-[5px] text-xs rounded h-[27px] flex items-center justify-center"
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                    : ''
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan="10" className="text-center">No hay información que mostrar con los parámetros seleccionados...</td></tr>
                        }
                        </tbody> 
                    </table>
                </div>
            </div>


            {ModalTracking()}
            {ModalEditarRegistrarOT()}
            {/* {ModalBIMsPendientes()} */}
            {ModalEliminarOT()}
            {/* {ModalCambioEstados_Old()} */}


            <Modal
                isOpen={isOpenBims}
                action={() => {
                    editarValorOrden('parametroCodBim',listaBimsSeleccionado)
                    notify('BIM´s agregados correctamente','success')
                    closeModalBims()
                }}
                closeModal={closeModalBims}
                title={'BIM´s pendientes'}
            >   
                <div className='w-[800px] lg:w-full p-1 max-h-[400px] overflow-auto'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Nº</th>
                                <th>FECHA</th>
                                <th>BIM</th>
                                <th>U.CREACION</th>
                                <th>CONDUCTOR</th>
                                <th>COMENTARIO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Object.keys(bimsPendientesPorUnidad).length != 0 && bimsPendientesPorUnidad.listaBim.length != 0 ?
                                    bimsPendientesPorUnidad.listaBim.map((data,i) => {
                                        if(bimsPendientesPorUnidad.listaBim?.length == 1 && listaBimsSeleccionado.length  == 0){
                                            setListaBimsSeleccionados([{codBim: data.codBitacoraIncidenciaMantenimiento}])
                                        }
                                        const isChecked = (bimsPendientesPorUnidad.listaBim?.length == 1) ? true : orden.codBitacoraIncidenciaMantenimiento?.split(',').some(e => e == data.codBitacoraIncidenciaMantenimiento)
                                        return(
                                            <tr key={i+1}>
                                                <td>{i+1}</td>
                                                <td>{data.fechaBim}</td>
                                                <td>{data.numDocumentoBim}</td>
                                                <td>{data.nomUsuarioCreacion}</td>
                                                <td>{data.nomPersonaConductor}</td>
                                                <td>{data.comentarioBim}</td>
                                                <td className='text-center'>
                                                    <input 
                                                        defaultChecked={isChecked}
                                                        onChange={(event) => {
                                                            const checkMarcado = event.target.checked

                                                            let listaBims = [...listaBimsSeleccionado]

                                                            if(checkMarcado){
                                                                listaBims.push({
                                                                    codBim: data.codBitacoraIncidenciaMantenimiento
                                                                })

                                                            }else{
                                                                listaBims = listaBims.filter(e => e.codBim != data.codBitacoraIncidenciaMantenimiento)

                                                            }
                                                            setListaBimsSeleccionados(listaBims)
                                                        }} 
                                                        type='checkbox' 
                                                        className='cursor-pointer'
                                                    />
                                                </td>
                                            </tr>
                                        )
                                    })
                                :
                                    <tr>
                                        <td colSpan={7} className='text-center'>No hay información...</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </Modal>

            {/* <div className=''>
                <div ref={diagnosticoRef} className='h-full bg-white'>
                    <GuiaDeSalida></GuiaDeSalida>
                </div>
            </div>

            <ReactToPrint
                trigger={() => <button>Imprimir Factura</button>}
                content={() => diagnosticoRef.current}
            /> */}
        </>
    )
}
